export default __webpack_public_path__ + "static/media/prirodna_better.9be26e96.jpg";